"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AudiencePickerView = void 0;
var _react = require("react");
var _AudiencePicker = require("../../AudiencePicker");
var _EnvironmentManager = require("../EnvironmentManager.provider");
var _EnvironmentManager2 = _interopRequireDefault(require("../EnvironmentManager.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var AudiencePickerView = function AudiencePickerView(props) {
  var view = props.view;
  var styles = (0, _EnvironmentManager2.default)();
  var _useContext = (0, _react.useContext)(_EnvironmentManager.EnvironmentManagerContext),
    audiencePickerProvider = _useContext.audiencePickerProvider,
    environmentData = _useContext.environmentData,
    getLabel = _useContext.getLabel;
  var isSelectedTeachers = environmentData.Teachers.length > 0;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: styles['cc-EnvironmentManager_AudiencePicker'],
    "data-testid": "audiencePickerView-".concat(view),
    children: isSelectedTeachers ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_AudiencePicker.AudiencePicker, _objectSpread(_objectSpread({}, audiencePickerProvider), {}, {
      view: view
    })) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        border: '1px solid rgb(224, 224, 224)',
        borderRadius: '.7rem',
        height: '100%',
        overflow: 'hidden',
        padding: '1rem',
        color: '#75758b'
      },
      children: getLabel('participants_should_select_operator_teachers')
    })
  });
};
exports.AudiencePickerView = AudiencePickerView;